<template>
  <div
    id="sidenav-collapse-main"
    class="w-auto h-auto collapse navbar-collapse"
  >
    <ul class="navbar-nav">
      <li
        v-for="(bot, index) in chatbots"
        :key="bot.id || index"
        class="nav-item d-flex justify-content-between align-items-center"
        @click.prevent="handleClick(bot.id)"
      >
        <sidenav-collapse
          :bot-id="bot.id"
          :isDeleteMode="isDeleteMode"
          :selectedBots="selectedBots"
          :nav-text="getBotStatusText(bot)"
          :collapse="false"
          :isDelete="!isProcessingBot(bot.id)"
          url="#"
          :aria-controls="''"
          collapse-ref="''"
          :class="getBotStatusClass(bot)"
          @bot-toggle="$emit('bot-toggle', $event)"
          @bot-deleted="$emit('bot-deleted', $event)"
        >
          <template #icon>
            <ChatIcon />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavCollapse from './SidenavCollapse.vue'
import { mapState } from 'vuex'
import ChatIcon from '@/components/Icon/ChatIcon.vue'

export default {
  name: 'SidenavList',
  components: {
    ChatIcon,
    SidenavCollapse,
  },
  props: {
    cardBg: {
      type: String,
      default: '',
    },
    chatbots: {
      type: Array,
      required: false,
      default: () => [],
    },
    isDeleteMode: Boolean,
    selectedBots: Array,
  },
  computed: {
    ...mapState(['isRTL']),

    conversationStatus() {
      return this.$store.state.conversationStatus
    },

    processingBotIds() {
      if (!this.conversationStatus?.data) return []
      return this.conversationStatus.data.map((item) => item.bot_id)
    },
  },
  methods: {
    handleClick(botId) {
      if (this.isDeleteMode) {
        this.$emit('bot-toggle', botId)
      } else {
        this.$emit('bot-selected', botId)
      }
    },
    getRoute() {
      const routeArr = this.$route.path.split('/')
      return routeArr[1]
    },
    getBotStatus(botId) {
      if (!this.conversationStatus?.data) return null

      const record = this.conversationStatus.data.find(
        (item) => item.bot_id === botId,
      )

      return record ? record.status : null
    },

    getBotStatusText(bot) {
      const status = this.getBotStatus(bot.id)

      if (status === 'processing') {
        return 'Deep Research中です...'
      }

      if (status === 'done') {
        return 'Deep Research完了しました'
      }

      return this.truncateBotName(bot.name)
    },
    getBotStatusClass(bot) {
      const status = this.getBotStatus(bot.id)

      if (status === 'processing') {
        return 'processing-text'
      }

      if (status === 'done') {
        return 'processing-complete'
      }

      return ''
    },
    isProcessingBot(botId) {
      return this.processingBotIds.includes(botId)
    },
    truncateBotName(name) {
      let bytes = 0
      let result = ''

      for (const char of name) {
        const charCode = char.charCodeAt(0)
        bytes += charCode > 255 ? 2 : 1 // 全角:2バイト, 半角:1バイト

        if (bytes > 18) {
          result += '…'
          break
        }
        result += char
      }

      return result
    },
  },
}
</script>
